var d3 = {
  ...require("d3-scale"),
  ...require("d3-selection"),
  ...require("d3-geo")
};

var geoJSON = require('../assets/chicago.json')

module.exports = function locator() {
  return {
    props: ['lat', 'lng', 'place'],
    template: require('./_locator.html'),
    data: function() {
      return {
        geojson: geoJSON
      }
    },
    methods: {
      showLocation: function() {

        //Width and height
        var width = 180;
        var height = 250;

        // create a first guess for the projection
        var center = d3.geoCentroid(this.geojson)
        var scale = 100;
        var projection = d3.geoMercator().scale(scale).center(center);
        //Define path generator
        var path = d3.geoPath()
                        .projection(projection);


                    
        // using the path determine the bounds of the current map and use
        // these to determine better values for the scale and translation
        var bounds = path.bounds(geoJSON);

        var hscale = scale * width / (bounds[1][0] - bounds[0][0]);
        var vscale = scale * height / (bounds[1][1] - bounds[0][1]);
        var scale = (hscale < vscale) ? hscale : vscale;
        var offset = [width - (bounds[0][0] + bounds[1][0]) / 14,
                      height - (bounds[0][1] + bounds[1][1]) / 4];

        // new projection
        projection = d3.geoMercator().center(center)
          .scale(scale * 0.9).translate(offset);
        
        path = path.projection(projection);

        let points =[this.lng, this.lat];


          //Create SVG element
          const svg = d3.select(this.$el)
            .append('svg')
            .attr("width", width)
            .attr("height", height)
            .attr("class", "community-area")

          //Bind data and create one path per GeoJSON feature
          const map = svg.append('g')
            .selectAll("path")
            .data(this.geojson.features)
            .enter()
            .append("path")
            .attr("d", path)
            .attr("class", d => "comm-area-" + d.properties.area_numbe)
            .attr('fill', function(d) {
              return 'white'
            });

          svg.selectAll("circle")
              .data([points]).enter()
              .append("circle")
              .attr("cx", function (d) { return projection(d)[0]; })
              .attr("cy", function (d) { return projection(d)[1]; })
              .attr("r", "8px")
              .attr("fill", "#f9954b")
        }
    }
  };
};